export const VariablesFilterData = [
    {
        "idFromColumnFilter": "name",
        "id": "name",
    },
    {
        "idFromColumnFilter": "pattern",
        "id": "pattern",
        "filterFn": (value, filterValue) => {
            const numberPattern = Number(value)
            return isNaN(numberPattern) ? value : numberPattern?.toFixed(2).includes(filterValue)
        }
    },
    {
        "idFromColumnFilter": "value",
        "id": "value",
        "filterFn": (value, filterValue) => {
            if (value == null || value === "") return false;
            const n = Number(value);
            const text = Number.isFinite(n) ? n.toFixed(2) : String(value);
            return text.includes(filterValue);
        }
    },
    {
        "idFromColumnFilter": "comment",
        "id": "comment",
    },
]